<template>
    <div class="tags-filter-bar d-flex align-center flex-wrap justify-content-between">
        <div class="tags-filter-search-bar">
            <el-input size="large" placeholder="Search Tags here...">
                <template #prefix>
                <el-icon class="el-input__icon"><Search /></el-icon>
                </template>
            </el-input>
        </div>

        <el-button-group>
            <el-button type="primary" size="medium" class="btn theme-btn-outline active-btn">Popular</el-button>
            <el-button type="primary" size="medium" class="btn theme-btn-outline">Name</el-button>
            <el-button type="primary" size="medium" class="btn theme-btn-outline">New</el-button>
        </el-button-group>
    </div>
</template>


<script>
import {Search} from '@element-plus/icons-vue';


export default {
    name: 'TagsFilterBar',
    components: {
        Search
    },
    data() {
        return {

        }
    }
}
</script>